<template>
  <div class="slider-wrapper" >

    <!-- if video -->
    <div class="justify-center slide slide-style-2 slider-video-bg d-flex align-center" data-black-overlay="6" v-if="showVideo">
        <v-container>
          <v-row align="center">
            <v-col cols="12">
              <div class="text-left inner">
                <img v-if="$t('logo.logoLight')&& $t('logo.logoLight')!=='logo.logoLight'" :src="$t('logo.logoLight')" class="logo-header" />
                <span class="theme-color font-700" v-if="headerVideo.viewSubtitle">{{ $t('video.subtitle')}}</span>
                <h1 class="heading-title mt--20" v-if="headerVideo.viewTitle" v-html="$t('video.title')"></h1>
                <p class="description" v-if="headerVideo.viewDesc">
                  {{ $t('video.desc')}}
                </p>
                <a id="banner-buy-ticket-btn" class="own-btn own-btn-yellow mt--30" v-if="activateBannerBuyTicketButtons" :href="$t('salePageUrl')" target="_blank" @click="trackTicketPurchase"><span>{{ $t('buttons.cta')  }}</span></a>
                <p class="color-white font-700 mt--10" v-if="activateBannerBuyTicketButtons && presale && seasonalPromoText">{{ seasonalPromoText  }}</p>
              </div>
            </v-col>
          </v-row>
          <v-row align="center">
            <v-col class="row banner_line mt--40 mb--30">
              <img src="/images/icons/header/line.svg" />
            </v-col>
          </v-row>
          <v-row align="center" v-if="!newIcons">
            <v-col class="row main_icons flex-row">
              <div>
                <img src="/images/icons/header/star-interactive.svg" />
              </div>
              <div>
                <img src="/images/icons/header/teddy-bear.svg" />
              </div>
              <div>
                <img src="/images/icons/header/outdoor.svg"  />
              </div>
              <div v-if="$t('bannerIcons.pet-friendly') !== 'bannerIcons.pet-friendly'">
                <img src="/images/icons/header/PetFriendly_icon1.png"  />
              </div>
            </v-col>
          </v-row>
          <v-row align="center" v-if="!newIcons">
            <v-col class="row main_icons_text">
              <div>
                <span>{{ $t('bannerIcons.interactive')  }}</span>
              </div>
              <div>
                <span>{{ $t('bannerIcons.family-friendly')  }}</span>
              </div>
              <div>
                <span>{{ $t('bannerIcons.outdoors')  }}</span>
              </div>
              <div v-if="$t('bannerIcons.pet-friendly') !== 'bannerIcons.pet-friendly'">
                <span>{{ $t('bannerIcons.pet-friendly')  }}</span>
              </div>
            </v-col>
          </v-row>

          <v-row align="center" v-if="newIcons">
            <v-col class="row main_icons flex-row">
              <div v-for="(icon, index) in mainBannerIcons" :key="index">
                <img :src="icon.icon" />
              </div>
            </v-col>
          </v-row>
          <v-row align="center" v-if="newIcons">
            <v-col class="row main_icons_text">
              <div v-for="(icon, index) in mainBannerIcons" :key="index">
                <span>{{ icon.description }}</span>
              </div>
            </v-col>
          </v-row>

        </v-container>
        <div class="video-background" >
          <span>
            <video muted="" autoplay="" playsinline="" loop="" poster="" v-if="headerVideo.src">
              <source :src="headerVideo.src"/>
            </video>
          </span>
        </div>
    </div>

    <!-- if slider -->
    <VueSlickCarousel
        v-bind="settings"
        class="slider-digital-agency slider-activation rn-slick-dot dot-light mb--0 color-white"
        v-if="headerImages.length">
      <div
          class="slide slide-style-2 fullscreen d-flex align-center bg_image"
          data-black-overlay="2"
          v-for="(slider, i) in headerImages"
          :key="i"
          :style="{ backgroundImage: 'url(' + slider.src + ')' }">

        <v-container>
          <v-row>
            <v-col cols="12">
              <div class="text-left inner">
                <img v-if="$t('logo.logoLight')" :src="$t('logo.logoLight')" class="logo-header" />
                <span class="theme-color font-700" v-if="slider.viewSubtitle">{{ $t('headerImages.' + slider.id + '.subtitle')  }}</span>
                <h1 class="heading-title mt--20" v-if="slider.viewTitle" v-html="$t('headerImages.' + slider.id + '.title') "></h1>
                <p class="description" v-if="slider.viewDesc">
                  {{ $t('headerImages.' + slider.id + '.desc')  }}
                </p>
                <a class="own-btn own-btn-yellow mt--30" v-if="activateBannerBuyTicketButtons" :href="$t('salePageUrl')" target="_blank" @click="trackTicketPurchase"><span>{{ $t('buttons.cta')  }}</span></a>
                <p class="color-white font-700 mt--10" v-if="activateBannerBuyTicketButtons && presale && seasonalPromoText">{{ seasonalPromoText  }}</p>
              </div>
            </v-col>
          </v-row>
          <v-row align="center">
            <v-col class="row banner_line mt--40 mb--30">
              <img src="/images/icons/header/line.svg" />
            </v-col>
          </v-row>

          <v-row align="center" v-if="!newIcons">
            <v-col class="row main_icons flex-row">
              <div>
                <img src="/images/icons/header/star-interactive.svg" />
              </div>
              <div>
                <img src="/images/icons/header/teddy-bear.svg" />
              </div>
              <div>
                <img src="/images/icons/header/outdoor.svg"  />
              </div>
            </v-col>
          </v-row>
          <v-row align="center" v-if="!newIcons">
            <v-col class="row main_icons_text">
              <div>
                <span>{{ $t('bannerIcons.interactive')  }}</span>
              </div>
              <div>
                <span>{{ $t('bannerIcons.family-friendly')  }}</span>
              </div>
              <div>
                <span>{{ $t('bannerIcons.outdoors')  }}</span>
              </div>
            </v-col>
          </v-row>

          <v-row align="center" v-if="newIcons">
            <v-col class="row main_icons flex-row">
              <div v-for="(icon, index) in mainBannerIcons" :key="index">
                <img :src="icon.icon" />
              </div>
            </v-col>
          </v-row>
          <v-row align="center" v-if="newIcons">
            <v-col class="row main_icons_text">
              <div v-for="(icon, index) in mainBannerIcons" :key="index">
                <span>{{ icon.description }}</span>
              </div>
            </v-col>
          </v-row>

        </v-container>

      </div>
      <!-- End Single Slide  -->
    </VueSlickCarousel>

    </div>
</template>
<script>
import {getLandingPageSettings} from "@/scripts/settings";
import {getSeasonalPresale} from "@/scripts/seasonalPresale";
import Banner from "@/components/slider/Banner.vue";
import VueSlickCarousel from "vue-slick-carousel";

export default {
  components: {Banner,VueSlickCarousel},

  data() {
    return {
      showVideo: false,
      showHeaderImage: false,
      headerVideo: null,
      headerImages: [],
      mainBannerIcons: [],
      newIcons: false,
      activateBannerBuyTicketButtons: false,
      settings: {
        fade: false,
        dots: false,
        arrows: false,
        infinite: true,
        speed: 1000
      },
      seasonalTicketsPresale: null,
      presale: false,
      seasonalPresaleKey: 'pricing.2'
    };
  },
  computed: {
    seasonalPromoText() {
      return this.$t(this.seasonalPresaleKey + '.SeasonalTicketsPromoText');
    }
  },
  mounted() {
    this.fetchSettings();
  },
  methods: {
    fetchSettings(){
      let landigpageName = this.$route.params.garden;
      if(!this.$route.params.garden){
         landigpageName = "corporate";
      }
      getLandingPageSettings(landigpageName).then((settings) => {
        if(settings.headerVideo){
          this.showVideo = true,
          this.headerVideo = settings.headerVideo;
        }else if(settings.headerImages){
          this.headerImages = settings.headerImages;
          this.showHeaderImage = true
        }
        this.activateBannerBuyTicketButtons = settings.activateBannerBuyTicketButtons;
        this.seasonalTicketsPresale = settings.seasonalTicketsPresale;
        this.setPresale();
      });
    },
    setPresale(){
      const stage = getSeasonalPresale(this.seasonalTicketsPresale);
      this.presale = !!stage;
      this.seasonalPresaleKey = stage && stage.translationKey ? stage.translationKey : 'pricing.2';
    },
    setIcons(){
      this.mainBannerIcons = this.$t('bannerIcons2');
      if(typeof this.mainBannerIcons === 'object' && this.mainBannerIcons !=='bannerIcons2'){
        this.newIcons = true;
      }else{
        this.newIcons = false;
      }
    },
    trackTicketPurchase() {
      if (window.dataLayer) {
        window.dataLayer.push({
          'event': 'buy_ticket_click',
          'market': this.$i18n.locale,
          'type': this.$route.params.garden,
          'clickSource': "header"
        });
      }
    }
  },
  watch: {
    '$i18n.messages': {
      handler: function() {
        this.setIcons();
      },
      deep: true,
      immediate: true
    }
  }
};
</script>